import { EmployeeMapper } from 'mapper/EmployeeMapper';

export const employeeMapper = new EmployeeMapper();
